import React from "react";
import Image from "react-bootstrap/Image";
import "bootstrap/dist/css/bootstrap.min.css";

const Avatar = ({ name, imageUrl, size = 40 }) => {
  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : "";
  };

  return (
    <>
      {imageUrl ? (
        <Image
          src={imageUrl}
          alt="User Avatar"
          roundedCircle
          width={size}
          height={size}
        />
      ) : (
        <div
          className="d-inline-flex align-items-center justify-content-center"
          style={{
            width: size,
            height: size,
            borderRadius: "50%",
            backgroundColor: "#007bff",
            color: "#fff",
            fontWeight: "bold",
            fontSize: size / 2,
          }}
        >
          {getInitial(name)}
        </div>
      )}
    </>
  );
};

export default Avatar;
